import { useState, useEffect, useMemo } from "react";
import { getEquipmentBrand, getEquipmentCategory } from "../../../api";

// Note: Implementation may change based on how the data is used
// on the frontend.

export function useCategorizedEquipments() {
  const [categories, setCategories] = useState([]);
  const [brands, setBrands] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchData() {
      try {
        setLoading(true);
        const [brandsRes, categoriesRes] = await Promise.all([
          getEquipmentBrand({
            all: "all",
          }),
          getEquipmentCategory(),
        ]);

        if (!categoriesRes.status) {
          throw new Error("Failed to fetch categories");
        }

        if (!brandsRes.status) {
          throw new Error("Failed to fetch brands");
        }

        setCategories(categoriesRes.data);
        setBrands(brandsRes.data);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    }

    fetchData();
  }, []);

  // useMemo is probably not needed since data doesn't change
  const categorizedEquipments = useMemo(() => {
    if (!categories.length || !brands.length) return [];

    return categories
      .map((cat) => ({
        id: cat.id,
        name: cat.category,
        type: cat.category_type,
        brands: [],
      }))
      .map((cat) => ({
        ...cat,
        totalEquipments: brands.reduce(
          (count, b) =>
            count + b.equipments.filter((e) => e.category_id === cat.id).length,
          0,
        ),
        brands: brands
          .filter((b) => b.equipments.some((e) => e.category_id === cat.id))
          .map((brand) => ({
            id: brand.id,
            name: brand.name,
            image: brand.image,
            description: brand.description,
            equipments: brand.equipments.filter(
              (e) => e.category_id === cat.id,
            ),
          })),
      }));
  }, [categories, brands]);

  return { categorizedEquipments, loading, error };
}
